import { LanguageType } from "@/custom-types";
import { PageSizeOption } from "@/graphql/generated";

export const pageSizeMapper = (pageSize: PageSizeOption, language: LanguageType) => {
  const texts = {
    en: {
      TWENTY_FIVE: '25',
      FIFTY: '50',
      SEVENTY_FIVE: '75',
      ONE_HUNDRED: '100',
    },
    es: {
      TWENTY_FIVE: '25',
      FIFTY: '50',
      SEVENTY_FIVE: '75',
      ONE_HUNDRED: '100',
    }
  }

  return texts[language][pageSize]
}

